export default __webpack_public_path__ + "static/media/LOLITA.c06388c5.jpg";